import * as absentLog from './absent/index.js';
import * as arrange from './arrange/index.js';
import * as campus from './campus/index.js';
import * as card from './card/index.js';
import * as cclass from './class/index.js';
import * as classroom from './classroom/index.js';
import * as comment from './comment/index.js';
import * as courseNew from './course/index.js';
import * as depart from './depart/index.js';
import * as evaluation from './evaluation/index.js';
import * as goods from './goods/index.js';
import * as growupRecord from './growup-record/index.js';
import * as locateAddress from './location/location.js';
import * as permission from './permission/index.js';
import * as prestoreCampus from './prestore-campus/index.js';
import * as Relation from './relation/relation.js';
import * as role from './role/index.js';
import * as sellPrices from './sell-prices/index.js';
import * as student from './student/index.js';
import * as teacher from './teacher/index.js';
import * as tuifei from './tuifei/index.js';
import * as timePeriods from './time-periods/index.js'
import * as approvalOpinion from './approval-opinion/index.js';
import * as sfType from './sf-type/index.js';
import * as belonger from './belonger/index.js';
import * as comform from './comform/index.js';
import * as studentClues from './student-clues/index.js';
import * as ceping from './ceping/index.js';
import * as storedCard from './stored-card/index.js';
import * as grade from './grade/index.js';


let routes = [
  ...absentLog.routes,
  ...arrange.routes,
  ...campus.routes,
  ...card.routes,
  ...cclass.routes,
  ...classroom.routes,
  ...comment.routes,
  ...courseNew.routes,
  ...depart.routes,
  ...evaluation.routes,
  ...goods.routes,
  ...growupRecord.routes,
  ...locateAddress.routes,
  ...permission.routes,
  ...prestoreCampus.routes,
  ...Relation.routes,
  ...role.routes,
  ...sellPrices.routes,
  ...student.routes,
  ...teacher.routes,
  ...tuifei.routes,
  ...timePeriods.routes,
  ...approvalOpinion.routes,
  ...sfType.routes,
  ...belonger.routes,
  ...comform.routes,
  ...studentClues.routes,
  ...ceping.routes,
  ...storedCard.routes,
  ...grade.routes
];

let side = {
  ...absentLog.api,
  ...arrange.api,
  ...campus.api,
  ...card.api,
  ...cclass.api,
  ...classroom.api,
  ...comment.api,
  ...courseNew.api,
  ...depart.api,
  ...evaluation.api,
  ...goods.api,
  ...growupRecord.api,
  ...locateAddress.api,
  ...permission.api,
  ...prestoreCampus.api,
  ...Relation.api,
  ...role.api,
  ...sellPrices.api,
  ...student.api,
  ...teacher.api,
  ...tuifei.api,
  ...timePeriods.api,
  ...approvalOpinion.api,
  ...sfType.api,
  ...belonger.api,
  ...comform.api,
  ...studentClues.api,
  ...ceping.api,
  ...storedCard.api,
  ...grade.api
};

side.sideRoutes = app.vxRouter.transRoutes(routes);


// setTimeout(() => {  
//   side.sideRoutes.forEach(route=>{
//     app.router.addRoutes([route]);
//     side[route.name] = function(options){
//       return new Promise((resolve, reject) => {
//         app.router.push(
//           route.path,
//           route => {
//             route.meta._resolve = resolve;
//             route.meta._reject = reject;
//             route.meta.options = options;
//           },
//           err => {
//             console.log(err);
//           }
//         );
//       });
//     }
//   })
// }, 0);

export default side;
